var ConfigureView = /** @class */ (function () {
    function ConfigureView(id, name, isMainView, type, width, height, configure, showSettingsWhenInited) {
        this.id = id;
        this.name = name;
        this.isMainView = isMainView;
        this.type = type;
        this.width = width;
        this.height = height;
        this.configure = configure;
        this.showSettingsWhenInited = showSettingsWhenInited;
    }
    return ConfigureView;
}());
export { ConfigureView };
